import { FormProperty } from './formProperty';
import { PropertyTypes } from '../enum/propertyTypes';
import { EventEmitter } from '@angular/core';
import { GSDropdownControl } from '../../controls/gsControls';

export class FormDropdownProperty extends FormProperty {
  options?: any[];
  source: any;
  type = PropertyTypes.Dropdown;
  component = GSDropdownControl;
  changed = new EventEmitter<any>();
  selectedValue: any;
  infoMessage;
  // #29557 - when true, no placeholder is rendered so PrimeNG's autoDisplayFirst shows the first
  // option for a null model (used where a null value IS a valid default option, e.g.
  // WeightedDistributionSource). Default (undefined/false) keeps the "Please select" placeholder.
  hidePlaceholder?: boolean;

  constructor(
    name: string,
    label: string,
    options?: [],
    row?: number,
    column?: number,
    rowspan?: number,
    columnspan?: number,
    valid?: boolean,
    public autoDisplayFirstDisabled?: boolean,
    public placeholder?: string,
    public showFilter?: boolean,
    public showClear?: boolean,
    styleClass?: string,
    labelClass?: string
  ) {
    super(name, label, row, column, rowspan, columnspan, valid, null, null, null, null, styleClass, labelClass);
    this.options = options ? options : this.options;
  }
}
